const formatNumber = (num) => {
  if (num === null || num === undefined) return "0,00";
  return parseFloat(num).toLocaleString("nb-NO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const isAbsoluteSet = (transaction) =>
  transaction?.quantity_basis === "absolute_set";

export const isSetDelta = (transaction) =>
  transaction?.quantity_basis === "set_delta";

export const isNotCounted = (transaction) =>
  transaction?.quantity_basis === "not_counted";

/** Count/opening rows — clipboard icon, not in/out arrows (incl. qty 0 not_counted). */
export const isCountBalanceRow = (transaction) =>
  isAbsoluteSet(transaction) || isSetDelta(transaction) || isNotCounted(transaction);

export const formatQuantityLabel = (transaction, t) => {
  const qty = formatNumber(transaction.quantity);
  if (isAbsoluteSet(transaction)) {
    return t("product.stock_report.quantity_set", { quantity: qty });
  }
  if (isSetDelta(transaction)) {
    const signed = transaction.quantity > 0 ? `+${qty}` : qty;
    return t("product.stock_report.quantity_set_delta", { quantity: signed });
  }
  if (isNotCounted(transaction)) {
    return t("product.stock_report.quantity_not_counted");
  }
  if (transaction.quantity > 0) return `+${qty}`;
  return qty;
};

/** Tailwind classes for the quantity cell (avoid red “outbound” look on not_counted). */
export const quantityToneClass = (transaction) => {
  if (isNotCounted(transaction)) return "text-gray-500";
  if (isAbsoluteSet(transaction)) return "text-blue-800 font-semibold";
  if (isSetDelta(transaction)) {
    if (transaction.quantity > 0) return "text-blue-800 font-semibold";
    if (transaction.quantity < 0) return "text-blue-700 font-semibold";
    return "text-blue-800 font-semibold";
  }
  if (transaction.quantity > 0) return "text-green-600 font-semibold";
  if (transaction.quantity < 0) return "text-red-600 font-semibold";
  return "";
};
